import { inputVariants } from '@/components/ui/Input';
import { cn } from '@/lib/utils';

export const fieldInput = {
  row: cn(inputVariants({ inputSize: 'sm' }), 'font-mono min-w-0'),
};
